<template>
  <v-chip :color="busenaColor" small outlined class="mr-2" v-if="isBusena">
    {{ busenaText }}
  </v-chip>
</template>

<script>
export default {
  name: 'ElBusena',
  props: {
    busena: [String, Boolean],
    color: { type: String, default: 'default' },
    taipNe: { type: Boolean, default: false },
  },
  computed: {
    isBusena() {
      return this.busena || this.taipNe
    },
    busenaColor() {
      if (this.taipNe) {
        return this.busena ? 'green' : 'default'
      } else {
        return this.color
      }
    },
    busenaText() {
      if (this.taipNe) {
        return this.busena ? 'Taip' : 'Ne'
      } else {
        return this.busena
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
